export default __webpack_public_path__ + "static/media/admin.75f0475a.svg";